// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M5 3H11C12.1 3 13 3.9 13 5V12.5C13 13.6 12.1 14.5 11 14.5H5C3.9 14.5 3 13.6 3 12.5V5C3 3.9 3.9 3 5 3Z',
  'M5.3 1.5V4.5M8 1.5V4.5M10.7 1.5V4.5',
  'M5.6 7H9.5M5.6 9.5H10.4M5.6 12H8.6',
];
